import request from '../utils/axios/request';
import { PaginationContent } from '../utils/types/pagination';
import { QueryClient } from './Client.service';
import { IContainer } from './Container.service';
import { IShip } from './Ship.service';
import { IYard } from './Yard.service';

export interface IMovement {
	id?: number;
	date?: Date;
	isArrived: boolean;
	owner: string;
	travelCode: string;
	yard: Partial<IYard>;
	ship: Partial<IShip>;
	containers: Partial<IContainer>[];
	createdAt?: Date;
	updatedAt?: Date;
	actions?: any;
}

abstract class MovementService {
	static async getAll(
		params: QueryClient,
		yardId?: number,
		shipId?: number
	): Promise<PaginationContent<IMovement> | undefined> {
		try {
			const response: PaginationContent<IMovement> = await request(
				'/movements/travel',
				'get',
				{
					params: { yardId, shipId, ...params },
				}
			);
			return response;
		} catch (error: any) {}
	}

	static async create(
		content: Omit<IMovement, 'owner'> & { owner: string[] },
		setError: React.Dispatch<React.SetStateAction<string>>
	) {
		try {
			const {
				id,
				yard,
				ship,
				createdAt,
				updatedAt,
				isArrived,
				containers,
				...data
			} = content;
			const handleContainers = containers.map((container) => ({
				...container,
				temperature:
					container.temperature === ''
						? null
						: Number(container.temperature),
				humidity:
					container.humidity === '' || container.humidity == null
						? null
						: Number(container.humidity),
				ventilation:
					container.ventilation === '' ||
					container.ventilation == null
						? null
						: Number(container.ventilation),
				atmosferaControlada: !!container.atmosferaControlada,
				nivelCo2:
					container.nivelCo2 === '' || container.nivelCo2 == null
						? null
						: Number(container.nivelCo2),
			}));
			const response = await request('/movements', 'post', {
				data: {
					...data,
					idYard: yard.id,
					idShip: ship.id,
					containers: handleContainers,
				},
			});
			return response;
		} catch (error) {
			setError('alert.error.generic');
		}
	}

	static async edit(
		data: IMovement,
		setError: React.Dispatch<React.SetStateAction<string>>
	) {
		try {
			const response = await request(`/movements/${data.id}`, 'patch', {
				data: {
					travelCode: data.travelCode,
					date: data.date,
				},
			});
			return response;
		} catch (error) {
			setError('alert.error.generic');
		}
	}
}

export default MovementService;
